import type { ScheduledCopyOverrides } from './scheduled-page-copy-types';

export const scheduledPageCopyOverridesArRu = {
  ar: {
    header: {
      navLabel: 'المجدولة',
      title: 'المجدولة',
      subtitle: 'مهام الوكيل التي تعمل تلقائيًا في الوقت الذي تختاره.',
      searchPlaceholder: 'البحث في الجداول',
      newSchedule: 'جدول جديد',
      create: 'إنشاء',
      createWithAgent: 'إنشاء باستخدام الوكيل',
      setUpManually: 'الإعداد يدويًا',
      createWithAgentPrompt:
        'ساعدني في إعداد مهمة مجدولة. اشرح كيف تعمل، ثم اسألني عما أحتاج إليه ومتى. اعرض لي معاينة للتأكيد.',
      timezone: 'الأوقات معروضة حسب {timezone}',
    },
    filters: {
      all: 'الكل',
      mine: 'الخاصة بي',
      shared: 'المشتركة',
      archived: 'المؤرشفة',
      filters: 'عوامل التصفية',
      moreScopes: 'المزيد من طرق عرض الجداول',
      status: 'الحالة',
      anyStatus: 'أي حالة',
      active: 'نشط',
      paused: 'متوقف مؤقتًا',
      completed: 'مكتمل',
    },
    calendar: {
      label: 'تقويم مهام الوكيل المجدولة',
      emptyTitle: 'خطط لمهمتك المجدولة التالية',
      more: '{count} إضافية',
      truncated:
        'توجد نتائج إضافية في هذا النطاق. ضيّق التواريخ أو عوامل التصفية لعرض الكل.',
      offlineTitle: 'أنت غير متصل',
      offlineDescription: 'أعد الاتصال لتحميل الجداول وإجراء التغييرات.',
      malformed: 'تعذر عرض هذا الجدول بأمان.',
      loading: 'جارٍ تحميل التقويم',
      allDay: 'المخطط الزمني للجداول',
    },
    common: {
      close: 'إغلاق',
      cancel: 'إلغاء',
      save: 'حفظ التغييرات',
      create: 'إنشاء الجدول',
      edit: 'تعديل',
      retry: 'إعادة المحاولة',
      back: 'رجوع',
      next: 'متابعة',
      loading: 'جارٍ التحميل',
      view: 'عرض',
      unknown: 'غير معروف',
      notAvailable: 'غير متاح',
    },
  },
  ru: {
    header: {
      navLabel: 'По расписанию',
      title: 'По расписанию',
      subtitle:
        'Задачи агента, которые выполняются автоматически в выбранное время.',
      searchPlaceholder: 'Поиск расписаний',
      newSchedule: 'Новое расписание',
      create: 'Создать',
      createWithAgent: 'Создать с агентом',
      setUpManually: 'Настроить вручную',
      createWithAgentPrompt:
        'Помоги мне настроить запланированную задачу. Объясни, как она работает, затем спроси, что и когда мне нужно. Покажи предварительный вариант для подтверждения.',
      timezone: 'Время указано в {timezone}',
    },
    filters: {
      all: 'Все',
      mine: 'Мои',
      shared: 'Общие',
      archived: 'Архив',
      filters: 'Фильтры',
      moreScopes: 'Другие представления расписания',
      status: 'Статус',
      anyStatus: 'Любой статус',
      active: 'Активно',
      paused: 'Приостановлено',
      completed: 'Завершено',
    },
    calendar: {
      label: 'Календарь запланированных задач агента',
      emptyTitle: 'Запланируйте следующую задачу',
      more: 'Ещё {count}',
      truncated:
        'В этом диапазоне есть другие результаты. Сузьте даты или фильтры, чтобы увидеть всё.',
      offlineTitle: 'Нет подключения',
      offlineDescription:
        'Подключитесь снова, чтобы загрузить расписания и внести изменения.',
      malformed: 'Не удалось безопасно отобразить это расписание.',
      loading: 'Загрузка календаря',
      allDay: 'Хронология расписания',
    },
    common: {
      close: 'Закрыть',
      cancel: 'Отмена',
      save: 'Сохранить',
      create: 'Создать расписание',
      edit: 'Изменить',
      retry: 'Повторить',
      back: 'Назад',
      next: 'Продолжить',
      loading: 'Загрузка',
      view: 'Просмотреть',
      unknown: 'Неизвестно',
      notAvailable: 'Недоступно',
    },
  },
} satisfies ScheduledCopyOverrides;
